// extracted by mini-css-extract-plugin
export default {"duesCard":"MembersPage_duesCard__+MFZA","cardTitle":"MembersPage_cardTitle__+Jrml"};